export default {
  sb: {
    "take-away": "ยกเลิก",
    "please-input": "โปรดป้อน",
    "please-select": "โปรดเลือก",
    "pack-up-screen": "ตัวกรองการบรรจุกล่อง",
    "more-screening": "ตัวกรองเพิ่มเติม",
    sure: "ตกลง",
    reset: "รีเซ็ต",
    query: "สอบถาม",
    to: "ถึง",
    "start-date": "วันที่เริ่มต้น",
    "end-date": "วันที่สิ้นสุด",
    "start-time": "เวลาเริ่มต้น",
    "end-time": "เวลาสิ้นสุด",
    "please-enter-the-content": "โปรดป้อนเนื้อหา",
    "upload-video": "อัปโหลดวิดีโอ",
    "please-upload-video-file": "กรุณาอัปโหลดวิดีโอ",
    "only-support-pm4": "รองรับการอัปโหลดไฟล์วิดีโอในรูปแบบ MP4 เท่านั้น",
    "select-all": "เลือกทั้งหมด",
    "selected-n-item": "เลือก {num} รายการ"
  }
};
